export default "__VITE_ASSET__DlM$Aj1___"